module.exports = __webpack_public_path__ + "img/detail-solution-2-1.41eb082c.png";